import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import styled from 'styled-components'
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import List from "@material-ui/core/List";
import _ from 'lodash';
import PrimaryButton from "components/Global/Buttons/PrimaryButton";

const styles = {
  list: {
    width: "1000px"
  },
  sideList: {
    padding: "15px"
  }
};

const MarginWrapper = styled.div`
  padding-right:10px;
  display: inline-block
`

class SearchCriteria extends React.Component {
  state = {
    top: false,
    left: false,
    bottom: false,
    right: false
  };

  componentDidUpdate(prevProps, prevState, snapshot){
    if(!_.isEmpty(this.props.events))
      this.processEvents(this.props.events);
  }

  processEvents = (events) => {
    var event = events[0];
    if(event.type === 'CLOSE')
      this.closeAll();
  }

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  closeAll = () => {
    this.setState({
      top: false,
      left: false,
      bottom: false,
      right: false
    });
    this.props.onCompleteEvent();
  }

  render() {
    const { classes } = this.props;

    const sideList = (
      <div className={classes.list}>
        <List>{this.props.tileData}</List>
      </div>
    );

    return (
      <MarginWrapper>
        <PrimaryButton          
          onClick={this.toggleDrawer("right", true)}          
        >
          Open Search Criteria
        </PrimaryButton>

        <SwipeableDrawer
          anchor="right"
          open={this.state.right}
          onClose={this.toggleDrawer("right", false)}
          onOpen={this.toggleDrawer("right", true)}
        >
          <div className={classes.sideList}>{sideList}</div>
        </SwipeableDrawer>
      </MarginWrapper>
    );
  }
}

SearchCriteria.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SearchCriteria);
